<template>
  <div>

    <ui-modal
      :alignTop="true"
      :alignTopMargin="20"
      :removeHeader="false"
      ref="modal"
      title="Detalle de tracking de booking"
      class="modal-tracking"
      size="auto"
      @close="ActionSetVisibleModalTrackingV2(false); ActionSetZindexTablaModal(false);">

      <div class="min-vh-100 d-flex justify-content-center align-items-start pattern-bg"
           style="overflow: hidden;border-radius: 10px;">

        <!-- CARD PRINCIPAL -->
        <div class="col-lg-12" style="width:100%; max-width:1100px;">

          <div class="card-body">

            <ui-tabs v-if="bookings.length" fullwidth class="tracking-booking-tabs">
              <ui-tab
                v-for="(booking, index) in bookings"
                :id="String(index)"
                :key="booking.id || booking.booking_number || index"
                :title="bookingTabTitle(booking, index)">

                <div class="d-flex align-items-center gap-2 mb-4 mt-4">
                  <span class="fw-semibold">BK :</span>
                  <span class="fw-semibold text-danger">{{ booking.booking_number || "-" }}</span>
                  <span class="badge bg-light text-dark fw-bold border">{{ booking.sealine_name || "-" }}</span>
                </div>

                <!-- ORIGEN / DESTINO -->
                <div class="route-card mb-4">

                  <div class="d-flex justify-content-between align-items-start mb-2">

                    <div>
                      <div class="fw-bold fs-5">
                        {{ getOriginName(booking) }}
                      </div>
                      <div class="text-muted">Origen</div>
                    </div>

                    <div class="text-center">
                      <span class="status-pill" :class="getStatusPillClass(booking)">
                        <span class="status-dot" :class="getStatusDotClass(booking)"></span>
                        {{ getStatusLabel(booking) }}
                      </span>
                    </div>

                    <div class="text-end">
                      <div class="fw-bold fs-5">
                        {{ getDestinationName(booking) }}
                      </div>
                      <div class="text-muted">Destino</div>
                    </div>

                  </div>


                  <!-- barra -->
                  <div class="route-bar-wrap">
                    <div class="route-dot left"></div>

                    <div class="route-track">
                      <div class="route-fill" :style="{ width: getProgressPercent(booking) + '%' }"></div>
                    </div>

                    <div class="route-dot right"></div>
                  </div>

                  <div class="text-muted mt-2">
                    Salida {{ formatDate(getStop(booking, "POL") && getStop(booking, "POL").date, "MMM DD") }}
                  </div>

                  <!-- ETA -->
                  <div class="eta-box mt-4">
                    <div class="eta-date">
                      {{ formatDate(getEtaDate(booking)) }}
                    </div>
                    <div class="eta-label">ETA</div>
                  </div>

                </div>

                <!-- CARD: CONTAINERS  -->
                <div class="card premium-card border-0">
                  <div class="card-body">

                    <h6 class="fw-semibold mb-3">
                      Contenedores
                    </h6>

                    <data-table-containers v-if="booking.containers"
                                           :table_id="containerTableId(index)"
                                           :shipping-status="getShippingStatus(booking)"
                                           :data="booking.containers">
                    </data-table-containers>

                  </div>
                </div>

                <!-- CARD: ROUTE PATH -->
                <div class="card premium-card border-0 mb-4">

                  <div class="card-body">

                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <h6 class="fw-semibold mb-0">
                        Mapa de ruta
                      </h6>
                    </div>

                    <shipping-route :points="getMapPath(booking)" :vessel-point="getVesselPosition(booking)"
                                    :api-key="'AIzaSyAbFcAHO6pjimB4AMHiplyhKGSfrdZXQHs'"></shipping-route>

                  </div>

                </div>

              </ui-tab>
            </ui-tabs>

            <div v-else class="text-center text-muted py-5">
              Sin tracking disponible
            </div>

          </div>

        </div>

      </div>

    </ui-modal>

  </div>

</template>

<script>
// Vuex
import { mapActions, mapState } from "vuex";
import { getTrackingDetailsV2 } from "@/constants/lineas";
import DataTableContainers from "@/components/dataTables/safecube/DataTableContainers.vue";
import ShippingRoute from "@/components/common/maps/ShippingRoute.vue";
import UiTabs from "keen-ui/src/UiTabs";
import UiTab from "keen-ui/src/UiTab";
import moment from "moment";

export default {
  components: { ShippingRoute, DataTableContainers, UiTabs, UiTab },
  props: {
    bookingNumber: {
      Default: String
    }
  },
  data() {

    return {
      data: []
    };

  },
  computed: {

    ...mapState(["visibleModalTrackingV2"]),

    ...mapState(["usuarioActual"]),

    bookings() {

      if (Array.isArray(this.data)) {

        return this.data;

      }

      if (this.data) {

        return [this.data];

      }

      return [];

    }

  },

  methods: {

    ...mapActions([
      "ActionSetVisibleModalTrackingV2",
      "ActionSetZindexTablaModal"
    ]),

    openModal(ref) {

      this.$refs[ref].open();

      this.ActionSetZindexTablaModal(true);

    },

    closeModal(ref) {

      this.$refs[ref].close();

    },

    bookingTabTitle(booking, index) {

      return `BK ${booking.booking_number || index + 1}`;

    },

    containerTableId(index) {

      return `track-cnt-dtbl-${index}`;

    },

    getStop(booking, stopType) {

      return (booking.stops || []).find(x => x.stop_type === stopType);

    },

    getOriginName(booking) {

      const stop = this.getStop(booking, "POL");

      return (stop && stop.location && stop.location.name) || booking.pol_name || "-";

    },

    getDestinationName(booking) {

      const stop = this.getStop(booking, "POD");

      return (stop && stop.location && stop.location.name) || booking.pod_name || "-";

    },

    getEtaDate(booking) {

      const stop = this.getStop(booking, "POD");

      return stop && (stop.predictive_eta || stop.date);

    },

    parseJsonField(raw, fallback) {

      if (!raw) return fallback;

      if (typeof raw !== "string") return raw;

      try {

        return JSON.parse(raw);

      } catch (e) {

        return fallback;

      }

    },

    getMapPath(booking) {

      const raw = this.parseJsonField(booking.path_data, []);

      if (Array.isArray(raw) && raw[0] && raw[0].path) {

        return raw.filter(r => r && r.routeType === "SEA").flatMap(r => Array.isArray(r.path) ? r.path : []);

      }

      if (Array.isArray(raw)) {

        return raw;

      }

      return [];

    },

    getVesselPosition(booking) {

      const raw = this.parseJsonField(booking.ais_data, null);

      if (raw && raw.lastVesselPosition) {

        const pos = raw.lastVesselPosition;

        return pos ? { lat: Number(pos.lat), lng: Number(pos.lng) } : null;

      }

      return null;

    },

    getShippingStatus(booking) {

      const meta = this.parseJsonField(booking.metadata, {});

      return ((meta && meta.shippingStatus) || "UNKNOWN").toUpperCase();

    },

    getProgressPercent(booking) {

      switch (this.getShippingStatus(booking)) {

        case "PLANNED":
          return 5;

        case "IN_TRANSIT":
          return 50;

        case "DELIVERED":
          return 100;

        case "UNKNOWN":
        default:
          return 0;

      }

    },

    getStatusLabel(booking) {

      switch (this.getShippingStatus(booking)) {

        case "IN_TRANSIT":
          return "En transito";

        case "DELIVERED":
          return "Entregado";

        case "PLANNED":
          return "Planificado";

        default:
          return "Desconocido";

      }

    },

    getStatusPillClass(booking) {

      switch (this.getShippingStatus(booking)) {

        case "IN_TRANSIT":
          return "pill-blue";

        case "DELIVERED":
          return "pill-green";

        case "PLANNED":
          return "pill-amber";

        default:
          return "pill-gray";

      }

    },

    getStatusDotClass(booking) {

      switch (this.getShippingStatus(booking)) {

        case "IN_TRANSIT":
          return "dot-blue";

        case "DELIVERED":
          return "dot-green";

        case "PLANNED":
          return "dot-amber";

        default:
          return "dot-gray";

      }

    },

    formatDate(date, format = "D MMM YYYY") {

      if (!date) return "-";

      return moment.utc(date).locale("es").format(format);

    }

  },

  watch: {

    async visibleModalTrackingV2(_new) {

      if (_new) {

        this.$vToastify.loader("Espere por favor...");

        try {

          const { status, data, message } = await getTrackingDetailsV2({ booking_number: this.bookingNumber });

          if (status === 200) {

            this.data = Array.isArray(data) ? data.filter(Boolean) : (data ? [data] : []);

            this.openModal("modal");

            return this.$vToastify.stopLoader();

          } else if (status === 400) {

            this.$vToastify.stopLoader();

            this.ActionSetVisibleModalTrackingV2(false);

            return this.$vToastify.info(message, "Booking sin tracking");

          } else {

            this.$vToastify.stopLoader();

            this.ActionSetVisibleModalTrackingV2(false);

            return this.$vToastify.error(message, "Error de tracking");

          }

        } catch (error) {

          this.ActionSetVisibleModalTrackingV2(false);

          this.$vToastify.stopLoader();

          return this.$vToastify.error("Se produjo un error inesperado", "Error");

        }

      } else {

        this.data = [];

      }

    }

  }

};
</script>

<style>

.modal-tracking .ui-modal__container {
  width: 90% !important;
}

.pattern-bg {
  background-color: #f6f6f7;
  background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23e1dee6' fill-opacity='0.4' fill-rule='evenodd'%3E%3Ccircle cx='3' cy='3' r='3'/%3E%3Ccircle cx='13' cy='13' r='3'/%3E%3C/g%3E%3C/svg%3E");
}

.premium-card {
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.10);
}

.route-card {
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.06);
  padding: 18px;
}

.route-bar-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}

.route-track {
  position: relative;
  flex: 1;
  height: 12px;
  background: rgba(220, 53, 69, 0.18); /* rojo suave */
  border-radius: 999px;
  overflow: hidden;
}

.route-fill {
  height: 100%;
  background: #dc3545; /* rojo fuerte */
  border-radius: 999px;
  transition: width .35s ease;
}

.route-dot {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: #dc3545;
  box-shadow: 0 10px 24px rgba(220, 53, 69, 0.18);
}

.eta-box {
  background: rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 16px;
  text-align: center;
}

.eta-date {
  font-size: 34px;
  font-weight: 700;
  letter-spacing: 0.3px;
  color: #111827;
}

.eta-label {
  margin-top: 2px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.55);
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 13px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.06);
  user-select: none;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
}

/* IN_TRANSIT (azul premium) */
.pill-blue {
  background: rgba(37, 99, 235, 0.10);
  color: #1D4ED8;
  border-color: rgba(37, 99, 235, 0.22);
}

.dot-blue {
  background: #2563EB;
}

/* DELIVERED (verde premium) */
.pill-green {
  background: rgba(22, 163, 74, 0.10);
  color: #15803D;
  border-color: rgba(22, 163, 74, 0.22);
}

.dot-green {
  background: #16A34A;
}

/* PLANNED (ambar premium) */
.pill-amber {
  background: rgba(245, 158, 11, 0.12);
  color: #B45309;
  border-color: rgba(245, 158, 11, 0.25);
}

.dot-amber {
  background: #F59E0B;
}

/* UNKNOWN (gris elegante) */
.pill-gray {
  background: rgba(107, 114, 128, 0.10);
  color: #374151;
  border-color: rgba(107, 114, 128, 0.20);
}

.dot-gray {
  background: #6B7280;
}

</style>
